import styled from '@emotion/styled';
import { colors } from 'theme/colors';

interface IModalContentProps {
  isCompact?: boolean;
}

export const ModalContent = styled('div')<IModalContentProps>(({ isCompact }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  backgroundColor: colors.white,
  borderRadius: '4px',
  border: `1px solid ${colors.primary500}`,
  padding: isCompact ? '20px' : '16px',
  margin: '16px',
  width: isCompact ? '100%' : '100%',
  maxWidth: '782px',
  minHeight: isCompact ? 'auto' : '360px',
  height: isCompact ? 'auto' : 'auto',
  maxHeight: '90vh',
  overflowY: 'auto',
  boxShadow: '0px 7px 14px 0px #053A6812, 0px 7px 7px 0px #053A6826',

  '@media (min-width: 600px)': {
    padding: isCompact ? '20px' : '24px',
    margin: 'auto',
    width: isCompact ? '782px' : '100%',
    minHeight: isCompact ? '188px' : '360px',
    height: isCompact ? '188px' : 'auto',
  },

  '@media (min-width: 900px)': {
    padding: isCompact ? '20px' : '32px',
  },
}));

export const CustomModalRoot = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1300,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  alignContent: 'center',
  backgroundColor: colors.modalBackdrop,
});

export const ButtonContainer = styled('div')<IModalContentProps>(({ isCompact }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  alignItems: 'stretch',
  marginTop: isCompact ? '16px' : '24px',
  width: '100%',

  '@media (min-width: 600px)': {
    flexDirection: 'row',
    gap: '16px',
    alignItems: 'center',
    marginTop: isCompact ? '16px' : '28px',
  },
}));
